module.exports = __webpack_public_path__ + "static/media/windows_Snow.be3a1532.mp4";